import { render } from "./boost-api-call.vue?vue&type=template&id=0debf78f"
import script from "./boost-api-call.vue?vue&type=script&lang=js"
export * from "./boost-api-call.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__